import React, { useContext, useEffect, useRef, useState } from "react";
import styled, { css, ThemeContext } from "styled-components";
import { transparentize } from "polished";

import MenuIcon from "icons/MenuIcon";
import AppProvider from "../App/AppProvider";
import media from "../../utils/media";
import { inIframe } from "../../utils/embed";
import { Theme } from "../../typedefs-ui/Theme";

const MenuButton = styled(MenuIcon)`
  padding: 0px 16px;
  min-width: 24px;
  ${props =>
    props.theme.scriptDirection === "rtl"
      ? css`
          padding-right: 18px;
        `
      : css`
          padding-left: 18px;
        `}
  ${media.desktop`display:none;`};
  ${inIframe() &&
    css`
      display: none;
    `};
`;

interface StyledAppBarProps {
  atTop: boolean;
}

// TODO: refactor 56px, it's AppBar's mobile min-height * 78% to allow
// for text to go behind the AppBar's linear-gradient allowing text to
// fade away when scrolling
// known uses:
// - src/components/UI/Viewer.tsx
// - src/components/Chapter/ChapterLayout/ChapterView.js
export const MAGIC_STYLED_APP_BAR_MOBILE_GRADIENT_START_PX_NUMBER = 56;

const StyledAppBar = styled.div<StyledAppBarProps>`
  font-family: ${props => props.theme.uiFont};
  z-index: 100;
  top: 0px;
  position: fixed;
  width: 100%;
  color: black;
  background: ${props => props.theme.background};
  background: linear-gradient(
    ${({ theme }) => `
      180deg,
      ${theme.background} 78%,
      ${transparentize(1, theme.background)} 100%
    `}
  );
  & > div {
    flex: 0 0 100%;
    display: flex;
    flex-direction: ${props =>
      props.theme.scriptDirection === "rtl" ? "row-reverse" : "row"};
    align-items: center;
    align-content: flex-start;
    min-height: 72px;
  }
  a {
    color: ${props => props.theme.appBarText};
  }
  ${media.desktop`
    color: black;
    width: auto;
    min-height: 86px;
    position: relative;

    a {
      color:
      color: #111111;
    }
  `};
`;

export const AppBarContentWrapper = styled.div`
  padding: 0 1rem;
`;

// props.showMenuButton doesn't have any effect??
interface AppBarProps {
  showMenuButton?: boolean;
  showBackButton?: boolean;
}

const AppBar: React.FC<AppBarProps> = ({ showMenuButton, children }) => {
  const appBarRef = useRef<HTMLDivElement>(null);
  const [atTop, setAtTop] = useState(false);
  const theme: Theme = useContext(ThemeContext);

  useEffect(() => {
    if (appBarRef && appBarRef.current) {
      const handleScroll = () => {
        const refRect = appBarRef!.current!.getBoundingClientRect();
        setAtTop(refRect.top <= 10);
      };

      window && window.addEventListener("scroll", handleScroll);
      return () => window && window.removeEventListener("scroll", handleScroll);
    }
  }, [appBarRef]);

  return (
    <StyledAppBar atTop={atTop}>
      <div ref={appBarRef}>
        {showMenuButton && (
          <AppProvider.Consumer>
            {({ toggleDrawer }) => (
              <MenuButton
                id="side-menu-button"
                onClick={toggleDrawer}
                size={24}
                color={theme.appBarText}
              />
            )}
          </AppProvider.Consumer>
        )}
        {children}
      </div>
    </StyledAppBar>
  );
};

export default AppBar;
